import Ajax from '@/libs/Ajax'

const nameSpace = '/aseapi/console/systemmgr'

export default {
  selectTable(param) {
    return Ajax.post(`${nameSpace}/filepersist/list`, param,{message:false})
  },
  del(paths) {
    return Ajax.post(`${nameSpace}/filepersist/delPersistents`, paths)
  },
  reSendMessage(paths) {
    return Ajax.post(`${nameSpace}/filepersist/reSendMessage`, paths)
  },
  fileContent(path) {
    return Ajax.get(`${nameSpace}/filepersist/fileContent`, {
      params: {
        path: path
      }
    })
  },
  transSelect() {
    return Ajax.get(`${nameSpace}/filepersist/transMission`)
  },
  dateSelect() {
    return Ajax.get(`${nameSpace}/filepersist/dateSelect`)
  },
  timeSelect() {
    return Ajax.get(`${nameSpace}/filepersist/timeSelect`)
  },
  getCsDir() {
    return Ajax.post(`${nameSpace}/filepersist/getcsdir`)
  },
  getQRCode(path) {
    return Ajax.get(`${nameSpace}/filepersist/getQRCode`, {
      params: {
        path: path
      }
    })
  },
}